module.exports = "<p class=\"text-justify\">{{ value }}</p>"